export enum STEP {
  INTRO = 'intro',
  CALENDAR = 'calendar',
  FORM = 'form',
  PREFERRED = 'preferred',
  BOOKED = 'success',
}